import { ListGroup, Button, Spinner } from "react-bootstrap"
import { FiDownload, FiTrash2 } from "react-icons/fi"
import * as DateFns from "date-fns"

type CsvFileListProps = {
  files: string[]
  isGenerating: boolean
  onDelete: (fileName: string) => void
  onDownload: (fileName: string) => void
}

export default function CsvFileList({ files, isGenerating, onDelete, onDownload }: CsvFileListProps) {
  const parseFileName = (fileName: string) => {
    const regex = /^(\d+)-(\d+)-(\d+)-(\d+)-(\d+)-(\d+)_([\d]+)(?:_wp)?\.csv$/
    const match = fileName.match(regex)

    if (!match) return null

    const [, year, month, day, hour, minute, second, count] = match.map((m, i) =>
      i === 0 ? m : Number(m) 
    )

    const date = new Date(
      year as unknown as number,
      (month as unknown as number) - 1,
      day as unknown as number,
      hour as unknown as number,
      minute as unknown as number,
      second as unknown as number
    )
    const formattedDate = DateFns.format(date, "yyyy-MM-dd HH:mm:ss")

    return {
      formattedDate,
      count,
      isWp: fileName.includes("_wp.csv"),
    }
  }

  return (
    <ListGroup style={{ height: "400px", overflowY: "scroll" }}>
      {isGenerating && (
        <ListGroup.Item className="d-flex justify-content-between align-items-center">
          <span className="text-muted">Uploader til WordPress..</span>
          <Spinner animation="border" size="sm" />
        </ListGroup.Item>
      )}
      {files.map((file, index) => {
        const info = parseFileName(file)

        return (
          <ListGroup.Item
            key={index}
            className="d-flex justify-content-between align-items-center"
          >
            <div>
              {info ? (
                <>
                  <div>{info.formattedDate}</div>
                  <div>Antal produkter: {info.count}</div>
                </>
              ) : (
                <div>{file}</div>
              )}
            </div>
            <div className="d-flex gap-2 align-items-center">
              {info?.isWp ? (
                <span className="text-success small mb-4">Automatisk Uploadet til WordPress</span>
              ) : (
                <>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={() => onDownload(file)}
                    title="Download"
                  >
                    <FiDownload />
                  </Button>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => onDelete(file)}
                    title="Slet fil"
                  >
                    <FiTrash2 />
                  </Button>
                </>
              )}
            </div>
          </ListGroup.Item>
        )
      })}
    </ListGroup>
  )
}
